/**
 * 配置信息
 */
import {changeArrToMap} from './assets/js/common'

let host = location.hostname;
let envStr = ''; // 环境变量
let env = '';
let sandboxEnv = '';
let sandboxGatewayEnv = '';

if (/-stg|-dev|localhost|^192\.168/.test(host)) {
  env = 'stg'
  envStr = '-stg';
  sandboxEnv = 'stg'
  sandboxGatewayEnv = '-stg'
} else if (/-pre/.test(host)) {
  env = 'pre'
  envStr = '-pre';
  sandboxEnv = 'stg';
  sandboxGatewayEnv = '-stg'
} else {
  env = 'prd'
  envStr = '';
  sandboxEnv = 'pre';
  sandboxGatewayEnv = '-pre'
}
let openStgUrl = `openapi${envStr}.huolala.cn`; // 开放平台对外地址
if (/-stg/.test(host)) {
    openStgUrl = 'http://buttonwood-stg.myhll.cn';
}
let openPrdUrl = 'openapi.huolala.cn'; // 开放平台对外地址

// 常用正则验证
let regCommon = {
    email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, // 邮箱
    phone: /^1{1}[0|3|4|5|6|7|8|9]{1}[0-9]{9}$/, // 手机号码
    tel: /^\d{7,12}$/, // 电话号码
    floatTwo: /^[0-9]+(.[0-9]{1,2})?$/, // 两位小数
    float: /^(-?\d+)(\.\d+)?$/, // 浮点数
    password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/, // 密码 (必须包含数字和字母)
    identityCard: /\d{17}[0-9Xx]$/, // 身份证 简易
    account: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, // 用户名 只允许字母数字汉字
};


// 教育程度
let educationList = [
    {
        value: 1,
        label: '高中'
    }, {
        value: 2,
        label: '中专'
    }, {
        value: 3,
        label: '大专'
    }, {
        value: 4,
        label: '本科'
    }, {
        value: 5,
        label: '硕士'
    }, {
        value: 6,
        label: '博士'
    }
];
let educationMap = changeArrToMap(educationList, 'value');

// 性别
let sexList = [
    {
        value: 1,
        label: '男'
    }, {
        value: 2,
        label: '女'
    }, {
        value: 3,
        label: '保密'
    }
];
let sexMap = changeArrToMap(sexList, 'value');

// 婚姻状况
let marriageList = [
    {
        value: 1,
        label: '已婚'
    }, {
        value: 2,
        label: '未婚'
    }
];
let marriageMap = changeArrToMap(marriageList, 'value');

// 应用状态
let appStatusList = [
    {
        value: 1,
        label: '待审核'
    }, {
        value: 2,
        label: '审核未通过'
    }, {
        value: 3,
        label: '上线运行'
    }, {
        value: 4,
        label: '已禁用'
    }
];
let appStatusMap = changeArrToMap(appStatusList, 'value');

// 授权状态
let authStatusList = [
    {
        value: 1,
        label: '有效'
    }, {
        value: 2,
        label: '已过期'
    }, {
        value: 3,
        label: '已终止'
    }
];
let authStatusMap = changeArrToMap(authStatusList, 'value');

// 授权状态
let ticketStatusList = [
    {
        type: 1,
        value: '待回答'
    }, {
        type: 2,
        value: '已结束'
    }, {
        type: 3,
        value: '已回答'
    },

];
let ticketStatusMap = changeArrToMap(ticketStatusList, 'type', 'value');


// 授权状态
let accountTypeList = [
    {
        value: 1,
        label: '货拉拉App账户'
    }, {
        value: 2,
        label: '货拉拉企业版App账户'
    }
];
let accountTypeMap = changeArrToMap(accountTypeList, 'value');

// 标签
let ticketTagList = [
    {
        value: 1,
        label: '咨询'
    }, {
        value: 2,
        label: '报障'
    }, {
        value: 3,
        label: '需求'
    }
];
let ticketTagMap = changeArrToMap(ticketTagList, 'value');

let ticketContentType = {
    0: '问题',
    1: "追问",
    2: "回答",
}

let searchTypes = [{
    type: 0,
    description: '全部',
    count: 0
}, {
    type: 1,
    description: 'API文档',
    count: 0
}, {
    type: 2,
    description: '接入指引',
    count: 0
}, {
    type: 3,
    description: '问题反馈',
    count: 0
}, {
    type: 4,
    description: '公告',
    count: 0
}]

// 标签
let ticketTypeList = [
    {
        value: 1,
        label: '授权'
    }, {
        value: 6,
        label: '计价'
    }, {
        value: 7,
        label: '下单'
    }, {
        value: 4,
        label: '城市车型'
    }, {
        value: 10,
        label: '优惠券'
    }, {
        value: 8,
        label: '支付'
    }, {
        value: 9,
        label: '账单'
    }, {
        value: 5,
        label: '其他'
    }, {
        value: 2,
        label: '消息推送'
    }, {
        value: 3,
        label: 'API权限'
    }
];
let envDesc = {
    1: '测试环境',
    2: '正式环境'
};
let ticketTypeMap = changeArrToMap(ticketTypeList, 'value');

// 需要缓存的组件
let keepAliveList = [];

export default {
    install(Vue) {
        //添加全局方法
        Vue.prototype.$config = {
            env,
            envStr,
            sandboxEnv,
            openStgUrl,
            openPrdUrl,
            keepAliveList, // 需要缓存的组件
            regCommon,
            educationList,
            educationMap,
            sexList,
            sexMap,
            marriageList,
            marriageMap,
            appStatusList,
            appStatusMap,
            authStatusList,
            authStatusMap,
            ticketStatusList,
            ticketStatusMap,
            accountTypeList,
            accountTypeMap,
            ticketTagList,
            ticketTagMap,
            ticketTypeList,
            ticketTypeMap,
            searchTypes,
            envDesc,
            ticketContentType
        }
    },
}



// WEBPACK FOOTER //
// ./src/config.js